import React from 'react';
import { Map, Marker } from 'google-maps-react';
import { useGoogle } from '@iso/lib/helpers/googleApiHelper';
import { attachGoogleNorthArrow } from '@iso/lib/helpers/mapFurniture';

// Australia fallback (used only when we have no pin / area / property centre).
const DEFAULT_CENTER = { lat: -25.3444, lng: 131.0369 };

const toNum = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : null;
};

/**
 * Drop / drag a pin to set a task's location, on a Google map. Emits
 * { lat, lng } (matching the backend `point` shape) or null when cleared.
 * Centres on the current pin, else the property centre, else the first area's
 * centroid, else the Australia default.
 */
const TaskLocationPicker = ({ value, onChange, areas = [], propertyCenter }) => {
  const { google, failed } = useGoogle();
  const hasValue = value && toNum(value.lat) !== null && toNum(value.lng) !== null;

  const areaCentroid = () => {
    const a = (areas || []).find(
      (o) => toNum(o.lat_centroid) !== null && toNum(o.lng_centroid) !== null
    );
    return a ? { lat: toNum(a.lat_centroid), lng: toNum(a.lng_centroid) } : null;
  };

  const center = hasValue
    ? { lat: toNum(value.lat), lng: toNum(value.lng) }
    : propertyCenter || areaCentroid() || DEFAULT_CENTER;

  const place = (lat, lng) => onChange({ lat, lng });

  return (
    <div>
      <div style={{ height: 260, borderRadius: 8, overflow: 'hidden', border: '1px solid #d9d9d9', position: 'relative' }}>
        {google ? (
          <Map
            google={google}
            zoom={hasValue ? 15 : 6}
            initialCenter={center}
            mapType="hybrid"
            onClick={(mapProps, map, e) => place(e.latLng.lat(), e.latLng.lng())}
            streetViewControl={false}
            mapTypeControl
            fullscreenControl={false}
            scaleControl
            onReady={(mapProps, map) => attachGoogleNorthArrow(map, mapProps.google)}
            containerStyle={{ position: 'relative', width: '100%', height: '100%' }}
            style={{ width: '100%', height: '100%' }}
          >
            {hasValue ? (
              <Marker
                position={{ lat: toNum(value.lat), lng: toNum(value.lng) }}
                draggable
                onDragend={(props, marker, e) => place(e.latLng.lat(), e.latLng.lng())}
              />
            ) : null}
          </Map>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#667085', textAlign: 'center', padding: 12 }}>
            {failed ? 'Map unavailable — the Google Maps script could not be loaded.' : 'Loading map…'}
          </div>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: 6,
          fontSize: 12,
          color: '#667085',
        }}
      >
        <span>
          {hasValue
            ? `Pinned at ${toNum(value.lat).toFixed(5)}, ${toNum(value.lng).toFixed(5)}`
            : 'Click the map to drop a pin (optional)'}
        </span>
        {hasValue ? (
          <a onClick={() => onChange(null)} style={{ cursor: 'pointer', color: '#cf1322' }}>
            Clear pin
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default TaskLocationPicker;
